export const aggregateData = (data) =>
  {
    if (data.length === 0)
    {
      return {}
    }

    const init = {}
    for (const key in data[0])
    {
      init[key] = 0
    }

    if (data.length === 0)
    {
      return init
    }

    const aggregated = data.reduce((a, b) => {
      const agg = {}

      for (const key in init)
      {
        agg[key] = a[key] + b[key]
      }

      return agg;
    }, init);

    return aggregated
  }

export const averageData = (data) =>
{
    const total = data.length;

    if (total === 0)
    {
        return {}
    }

    const aggregated = aggregateData(data)
    const average = {}

    for (const key in aggregated)
    {
        average[key] = Math.round(aggregated[key]/total * 10) / 10 // rounded to 1 decimal points
    }

    return average
}

export const filterDataByDate = (data, startDate, endDate) =>
{
  const filteredData = []

  data.forEach((record) =>
  {
    const subTime = record.submissionTime
    if (subTime >= new Date(startDate).setUTCHours(0) && subTime <= new Date(endDate).setUTCHours(0))
    {
      filteredData.push(record)
    }
  })

  return filteredData;
}

export const aggregateDataByUser = (data) =>
{
  const aggregatedData = []

  data.forEach((record) =>{
    const indexOfUserRecord = aggregatedData.findIndex(e => e.email === record.email);

    if (indexOfUserRecord > -1)
    {
      for (const field in record)
      {
        if (typeof record[field] === 'number') // only aggregate fields that are numerical 
        {
          aggregatedData[indexOfUserRecord][field] = aggregatedData[indexOfUserRecord][field] + record[field]
        }
      }
    }
    else // if we haven't seen this user yet
    {
      const aggregatedRecord = {}
      aggregatedRecord.email = record.email

      for (const field in record)
      {
        aggregatedRecord[field] = record[field]
      }

      aggregatedData.push(aggregatedRecord)
    }

  })

  return aggregatedData
}

export const aggregateDataByMonth = (data) =>
{
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const aggregatedData = []

  data.forEach((record) => {

    const subTime = record.submissionTime
    const date = new Date(subTime);
    const monthIndex = date.getMonth();

    const indexOfMonthRecord = aggregatedData.findIndex(e => e.month === months[monthIndex]);

    if (indexOfMonthRecord > -1)
    {
      for (const field in record)
      {
        if (typeof record[field] === 'number') // only aggregate fields that are numerical 
        {
          aggregatedData[indexOfMonthRecord][field] = aggregatedData[indexOfMonthRecord][field] + record[field]
        }
      }
    }
    else // if we haven't seen this user yet
    {
      const aggregatedRecord = {}
      aggregatedRecord.month = months[monthIndex]

      for (const field in record)
      {
        aggregatedRecord[field] = record[field]
      }

      aggregatedData.push(aggregatedRecord)
    }

  })

  // copied
  const monthDates = aggregatedData.map(e => new Date(`01 ${e.month} 2000`));
  // Sort the array by the Unix timestamp of each Date object
  monthDates.sort((a, b) => a.getTime() - b.getTime());
  // Return an array of month names sorted by time
  const aggregatedDataSorted = monthDates.map(date => aggregatedData.find(object => object.month === date.toLocaleString('default', { month: 'long' })));

  return aggregatedDataSorted
}

// done with chatGPT assistance
export const averageWeekPerMonth = (data) =>
{
  const aggregatedData = data.reduce((result, item) =>
  {
    const date = new Date(item.submissionTime);
    const week = Math.floor((date.getDate() - 1) / 7) + 1;
    const month = date.getMonth() + 1; // calculate month number
    const key = `${month}-${week}`; // create key in format "month-week"
    
    if (!result[key]) {
      result[key] = { count: 0, sum: 0 };
    }
  
    result[key].sum += item.total;
  
    return result;
  }, {});

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const averagedData = Object.entries(aggregatedData).reduce((result, [key, value]) => {    
    const [month, week] = key.split('-');
    const total = value.sum;

    if (!result[month]) {
      result[month] = [];
    }

    result[month].push({ week, total });

    return result;
  }, {});

  const result = Object.entries(averagedData).map(([month, weeks]) => {
    const total = weeks.reduce((sum, { total }) => sum + total, 0) / weeks.length;
    return { month, total };
  });

  const renamedResult = result.map((record) => {
    record.month = months[record.month - 1]
    record.total = Math.round(record.total * 10) / 10
    return record
  })
    
  return renamedResult
}

export const filterDataByFields = (data, fields) =>
{
  const filteredData = []

  data.forEach((record) => 
  {
    const filteredRecord = {}
    // filteredRecord.email = record.email

    fields.forEach( (field) =>
    {
      filteredRecord[field] = record[field]
    })

    filteredData.push(filteredRecord)
  })

  return filteredData
}

export const filterDataByUser = (data, users) =>
{
  const filteredData = []

  data.forEach((record) =>
  {
    const found = users.find((user) => user.email === record.email) !== undefined ? true : false

    if (found)
    {
      filteredData.push(record)
    }
  })

  return filteredData;
}